import { createdRentalSchema } from "schemas";
import { apiClient } from "../client";

export const chargeFirstInstalment = async (sessionId: string) =>
  createdRentalSchema.parse(
    (await apiClient.post(`sessions/${sessionId}/charge_first_instalment`)).data
  );
